<template>
  <Admin/>
</template>

<script>
import Admin from './backend/Admin.vue'
export default {
  name: 'App',
  components: {
    Admin
  },
  async mounted() { 
    this.$store.state.isAdmin = 2
  },
}
</script>
